import React, { useState, useEffect, useMemo } from 'react';
import { kazanimSozleri } from '../../lib/dersler';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// Yapısal kazanım seçici: /api/kazanim haritasından KONU → ALT KONU/KAZANIM
// kaskadı (App.js filter-bar kaskadının Basım portu). Seçim value (kazanim_kodu)
// olarak yukarı yazılır; backend prefix eşlemesi alt kazanımları da kapsar.
function KazanimSecici({ apiUrl, ders, mufredat, value, onChange, onSecilenBilgi }) {
  const [harita, setHarita] = useState(null);
  const [konuKod, setKonuKod] = useState('');

  // Ders/müfredat değişince haritayı yeniden çek + kaskadı sıfırla.
  useEffect(() => {
    setKonuKod('');
    const token = localStorage.getItem('yks_token');
    const params = new URLSearchParams();
    if (ders) params.set('ders', ders);
    if (mufredat === 'Maarif_2024') params.set('mufredat', 'Maarif_2024');
    const qs = params.toString();
    fetch(`${apiUrl}/api/kazanim${qs ? `?${qs}` : ''}`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    })
      .then(r => r.json())
      .then(d => setHarita(Array.isArray(d.konular) ? d.konular : null))
      .catch(() => setHarita(null));
  }, [apiUrl, ders, mufredat]);

  // Konu optgroup'ları: sinif alanı doluysa sınıfa göre (ders önekine daraltılmış),
  // sinif=null haritalarda (ör. biyoloji MEB) sinav_tipi (TYT/AYT) fallback'i.
  const gruplar = useMemo(() => {
    if (!harita || harita.length === 0) return [];
    const d = ders || '';
    const siniflar = d.startsWith('tyt_') ? [9, 10] : d.startsWith('ayt_') ? [11, 12] : [9, 10, 11, 12];
    const sinavlar = d.startsWith('tyt_') ? ['TYT'] : d.startsWith('ayt_') ? ['AYT'] : ['TYT', 'AYT'];
    let g;
    if (harita.some(k => k.sinif != null)) {
      g = siniflar
        .map(s => ({ label: `${s}. Sınıf`, konular: harita.filter(k => k.sinif === s) }))
        .filter(x => x.konular.length > 0);
    } else {
      g = sinavlar
        .map(st => ({ label: st, konular: harita.filter(k => (k.sinav_tipi || '') === st) }))
        .filter(x => x.konular.length > 0);
    }
    // Güvenlik ağı: daraltma her şeyi elediyse düz liste göster.
    if (g.length === 0) g = [{ label: 'Konular', konular: harita }];
    return g;
  }, [harita, ders]);

  const seciliKonu = harita && konuKod ? harita.find(k => k.kod === konuKod) : null;
  // Faz C: kod -> ad çözümü (KazanimListesi çipleri kodun yanında adı gösterir).
  const kazanimAdBul = (konu, kod) => {
    if (!konu) return kod;
    if (kod === konu.kod) return konu.ad || kod;
    for (const ak of (konu.alt_konular || [])) {
      if (ak.kod === kod) return ak.ad || kod;
      for (const kaz of (ak.kazanimlar || [])) if (kaz.kod === kod) return kaz.ad || kod;
    }
    return kod;
  };

  if (!harita || harita.length === 0) return null;
  const k = kazanimSozleri(mufredat);
  return (
    <div>
      <label className="block text-[10px] font-bold text-gray-500 mb-1 uppercase">{k.Ad} (opsiyonel)</label>
      <div className="space-y-1">
        <select value={konuKod} aria-label={`${k.Ad} konusu`}
          onChange={e => {
            const kod = e.target.value;
            setKonuKod(kod);
            onChange(kod || '');
            if (onSecilenBilgi) onSecilenBilgi(kod ? { kod, ad: (harita.find(k => k.kod === kod) || {}).ad || kod } : null);
          }}
          className="w-full px-2.5 py-1.5 rounded-lg border border-gray-300 text-xs">
          <option value="">Tüm {k.Adlar}</option>
          {gruplar.map(g => (
            <optgroup key={g.label} label={g.label}>
              {g.konular.map(k => <option key={k.kod} value={k.kod}>{k.kod} {k.ad}</option>)}
            </optgroup>
          ))}
        </select>
        {seciliKonu && (
          <select value={value === konuKod ? '' : (value || '')} aria-label={`${k.Ad} detayı`}
            onChange={e => {
              const kod = e.target.value || konuKod;
              onChange(kod);
              if (onSecilenBilgi) onSecilenBilgi({ kod, ad: kazanimAdBul(seciliKonu, kod) });
            }}
            className="w-full px-2.5 py-1.5 rounded-lg border border-indigo-300 text-xs">
            <option value="">Tüm {seciliKonu.ad}</option>
            {(seciliKonu.alt_konular || []).map(ak => (
              <optgroup key={ak.kod} label={`${ak.kod} ${ak.ad}`}>
                <option value={ak.kod}>↳ Tümü</option>
                {(ak.kazanimlar || []).map(kaz => (
                  <option key={kaz.kod} value={kaz.kod}>
                    {kaz.kod} {kaz.ad && kaz.ad.length > 40 ? kaz.ad.substring(0, 40) + '…' : kaz.ad}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}

export default KazanimSecici;
